var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTodos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.75C0 2.12665 2.12665 0 4.75 0H14.75C17.3734 0 19.5 2.12665 19.5 4.75V13.25C19.5 13.9404 18.9404 14.5 18.25 14.5C17.5596 14.5 17 13.9404 17 13.25V4.75C17 3.50736 15.9926 2.5 14.75 2.5H4.75C3.50736 2.5 2.5 3.50736 2.5 4.75V19.75C2.5 20.9926 3.50736 22 4.75 22H11.25C11.9404 22 12.5 22.5596 12.5 23.25C12.5 23.9404 11.9404 24.5 11.25 24.5H4.75C2.12665 24.5 0 22.3734 0 19.75V4.75ZM23.2933 13.4104C23.7569 13.7105 23.8896 14.3296 23.5896 14.7933L18.0896 23.2933C17.9119 23.5678 17.6114 23.7381 17.2846 23.7494C16.9578 23.7607 16.6462 23.6116 16.45 23.35L13.45 19.35C13.1186 18.9082 13.2082 18.2814 13.65 17.95C14.0918 17.6186 14.7186 17.7082 15.05 18.15L17.1895 21.0027L21.9104 13.7067C22.2105 13.2431 22.8296 13.1104 23.2933 13.4104ZM6.25 6C5.55964 6 5 6.55964 5 7.25C5 7.94036 5.55964 8.5 6.25 8.5H13.25C13.9404 8.5 14.5 7.94036 14.5 7.25C14.5 6.55964 13.9404 6 13.25 6H6.25ZM5 12.25C5 11.5596 5.55964 11 6.25 11H13.25C13.9404 11 14.5 11.5596 14.5 12.25C14.5 12.9404 13.9404 13.5 13.25 13.5H6.25C5.55964 13.5 5 12.9404 5 12.25ZM6.25 16C5.55964 16 5 16.5596 5 17.25C5 17.9404 5.55964 18.5 6.25 18.5H10.25C10.9404 18.5 11.5 17.9404 11.5 17.25C11.5 16.5596 10.9404 16 10.25 16H6.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTodos);
export default __webpack_public_path__ + "static/media/ic_todos.224e6ed8a70ca6e5415b742bfd88e2b6.svg";
export { ForwardRef as ReactComponent };